<template>
  <!-- 轮播图 -->
  <div class="banner">
    <div class="item" :style="getItemWidth">
      <template v-for="(banner,index) in bannerList">
        <div class="banner-d" :key="index">
          <template v-if="fullFlag(banner.src)">
            <img style="display:none" :ref="'full-img-' + index" :src="banner.src" @load="imgLoad('full-img-' + index,'img-' + index)">
            <img :ref="'img-' + index" :src="getLowPixel(banner.src)">
          </template>
          <template v-else>
            <img :src="banner.src">
          </template>
        </div>
      </template>
    </div>


    <div class="dots">
      <template v-for="(banner,index) in bannerList">
        <a :data-index=index href="#" :class="{'dot':true,'active':index == 0}" :key="index"></a>
      </template>
    </div>
    <div class="page">
      <a href="#"><img src="@/static/icon/left.svg" alt=""></a>
      <a href="#"><img src="@/static/icon/right.svg" alt=""></a>
    </div>
  </div>
</template>

<script>
import { getBannerList } from '@/api/bannerApi'

export default {
  name: "h-banner",
  data(){
    return{
      dataset:{},
      bannerList:[],
    }
  },
  computed: {
    getItemWidth() {
      return {
        width: this.bannerList?.length * 100 + '%',
      };
    },
  },
  mounted() {
    this.init();
  },
  methods:{
    init(){
      this.getBannerList();
    },
    getBannerList(){
      const $this = this;
      getBannerList({type:'1'}).then(res =>{
        $this.bannerList = res.data;
        $this.$nextTick(()=>{
          $this.banner();
        })
      })
    },
    // 轮播图
    banner() {
      var item = document.querySelector(".item") //获取图片的父容器
      var tabList = document.querySelectorAll(".banner .item .banner-d") //获取每一个图片
      var dot = document.querySelectorAll(".banner .dots .dot") //轮播图中的下面的园
      var pageList = document.querySelectorAll(".page a") //轮播图中的两个翻页
      var banner = document.querySelector(".banner") //banner容器
      var index = 0 //用来获取tabList中的data-index 的下标
      var timer //定时器名
      var len = tabList.length //获取tabList的长度
      var width //banner的宽度

      // 判断浏览器可视宽度是否改变 window.onresize

      // 如果改变浏览器宽度则会直接获取当前宽度
      // 如果不设置则有可能在浏览器宽度变宽窄时会出现图片跑过头一点
      window.onresize = function () {
        width = parseInt(getComputedStyle(banner).width)
        if (width !== parseInt(item.style.transform.substr(12))) {
          item.style.transform = "translate3d(-" + index * width + "px,0px,0px)"
        }

      }

      // 上一页
      pageList[0].onclick = function () {
        clearInterval(timer)
        index = index - 1
        if (index === -1) {
          index = len - 1
        }
        clearActive()
        carousel()
      }

      // 下一页
      pageList[1].onclick = function () {
        clearInterval(timer)
        index = index + 1
        if (index === len) {
          index = 0
        }
        clearActive()
        carousel()
      }

      // 自动轮播
      function carousel() {
        timer = setInterval(function () {
          index++
          if (index === len) {
            index = 0
          }
          clearActive()

          // dot[index].classList.add("active")
          // item.style.transform = "translate3d(-" + index * 1903 + "px,0px,0px)"
        }, 5000)
      }

      // 清除并添加样式
      function clearActive() {
        width = parseInt(getComputedStyle(banner).width)
        for (var j = 0; j < len; j++) {
          dot[j].classList.remove("active")
          dot[index].classList.add("active")
          item.style.transform = "translate3d(-" + index * width + "px,0px,0px)"
        }
      }

      // 点击超链接可以跳转到指定的位置
      function dots() {
        for (var i = 0; i < len; i++) {
          dot[i].onclick = function () {
            clearInterval(timer)
            index = this.dataset.index
            clearActive()

            // this.classList.add("active")
            // item.style.transform = "translate3d(-" + index * 1903 + "px,0px,0px)"
            carousel()
          }
        }
      }

      carousel()
      dots()
    },
    imgLoad(full,lowPixel){
      this.$refs[full][0].style.display = 'block';
      // this.$refs[lowPixel][0].style.display = 'none';
      this.$refs[lowPixel][0].remove();
    },
    /**
     * 判断是否高清图片
     */
    fullFlag(url){
      const hasFullSuffix = url.includes("-full");
      return hasFullSuffix;
    },
    /**
     * 高清图片优先加载低像素
     * @param url
     * @returns {*}
     */
    getLowPixel(url){
      // 如果包含 -full 后缀，则去掉它
      const lowPixel = url.replace("-full", "");
      return lowPixel;
    }
  }
}
</script>

<style scoped>

</style>
